<template>
  <div class="pc-video">
    <!-- PC端头部 -->
    <header class="pc-header">
      <div class="header-container">
        <div class="logo">
          <img src="/img/study.png" alt="logo" class="logo-img" />
          <span class="logo-title">上岸</span>
        </div>
        <nav class="nav-menu">
          <router-link to="/" class="nav-item">首页</router-link>
          <router-link to="#" class="nav-item active">课程</router-link>
          <a href="#about" class="nav-item">关于我们</a>
        </nav>
        <div class="user-actions">
          <span class="user-name">欢迎您，{{ userName || '请登录' }}</span>
          <button class="btn-mine-outline" @click="goMine">我的</button>
        </div>
      </div>
    </header>

    <!-- 面包屑 -->
    <div class="pc-video-top">
      <div class="top-inner">
        <a class="breadcrumb-link" @click="goBack">‹ 返回课程</a>
        <span class="breadcrumb-divider">|</span>
        <span class="breadcrumb-current">{{ name || '视频播放' }}</span>
      </div>
    </div>

    <!-- 主体 -->
    <section class="pc-video-body">
      <div class="body-inner">
        <!-- 播放器 -->
        <div class="player-wrap">
          <div id="mse" class="player-box"></div>
        </div>

        <!-- 视频信息 -->
        <div class="info-card" v-if="name">
          <div class="info-left">
            <span class="info-badge">正在播放</span>
            <h2 class="info-name">{{ name }}</h2>
            <div class="info-meta">
              <span>视频课程</span>
              <span class="meta-sep">·</span>
              <span>在线学习</span>
            </div>
          </div>
          <div class="info-right">
            <button class="info-back-btn" @click="goBack">返回课程列表 ›</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="pc-footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>关于我们</h3>
            <p>致力于为学习者提供优质的在线教育资源，助力每个人实现学习目标。</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2025 ShangAn. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Player from 'xgplayer';
import 'xgplayer-mp4';
import { get_video_info } from "@/api/category";
import request from "@/utils/request";

export default {
  name: 'VideoPC',
  data() {
    return {
      name: '',
      loading: true,
      player: null
    };
  },
  computed: {
    ...mapState({
      userName: state => state.user && state.user.name
    })
  },
  created() {
    document.oncontextmenu = function () { return false; };
    this.$nextTick(() => {
      this.initVideo();
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.destroy();
    }
  },
  methods: {
    async initVideo() {
      try {
        const { status, data } = await get_video_info(this.$route.params.id);
        if (status !== 200) throw '获取视频信息失败';
        const url = `https://cdn.lxtech528.cn${data.data[0].address}`;
        this.name = data.data[0].name;
        this.recordProgress();
        this.player = new Player({
          el: document.querySelector('#mse'),
          url: url || '',
          videoInit: true,
          fluid: true,
          height: 0.8,
          width: 1,
          playbackRate: [0.75, 1, 1.5, 2],
          defaultPlaybackRate: 1,
          controlsList: ['nodownload'],
          preloadTime: 10,
          closeVideoClick: true,
          closeVideoTouch: true,
          closeVideoDblclick: true,
          playsinline: true
        });
        this.player.once('canplay', () => {
          this.loading = false;
        });
      } catch (err) {
        this.$createToast({
          txt: err,
          type: "error",
          time: 1500
        }).show();
        setTimeout(() => {
          this.$router.push("/login");
        }, 1500);
      }
    },
    recordProgress() {
      request({
        url: '/api/users/progress',
        method: 'post',
        data: {
          video_id: this.$route.params.id,
          video_name: this.name,
          category_id: this.$route.query.categoryId || ''
        }
      }).catch(() => {});
    },
    goBack() {
      this.$router.go(-1);
    },
    goMine() {
      this.$router.push(this.userName ? '/mine' : '/login');
    }
  }
};
</script>

<style>
@import "../assets/stytels/home-pc.css";

/* ---- 面包屑 ---- */
.pc-video-top {
  margin-top: 70px;
  background: #1a1a2e;
  padding: 14px 20px;
}

.top-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.breadcrumb-link {
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumb-link:hover {
  color: #fff;
}

.breadcrumb-divider {
  color: rgba(255, 255, 255, 0.25);
}

.breadcrumb-current {
  color: rgba(255, 255, 255, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ---- 主体 ---- */
.pc-video-body {
  background: #0a0a0f;
  min-height: 500px;
  padding: 0 20px 40px;
}

.body-inner {
  max-width: 1100px;
  margin: 0 auto;
}

/* ---- 播放器 ---- */
.player-wrap {
  background: #000;
  border-radius: 0 0 10px 10px;
  overflow: hidden;
}

.player-box {
  width: 100%;
  min-height: 480px;
}

/* ---- 信息卡片 ---- */
.info-card {
  background: #fff;
  border-radius: 10px;
  margin-top: 24px;
  padding: 24px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.info-left {
  flex: 1;
  min-width: 0;
}

.info-badge {
  display: inline-block;
  font-size: 12px;
  color: #667eea;
  background: #eef0ff;
  padding: 3px 14px;
  border-radius: 12px;
  margin-bottom: 10px;
}

.info-name {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 8px;
  line-height: 1.4;
}

.info-meta {
  font-size: 13px;
  color: #999;
}

.meta-sep {
  margin: 0 6px;
  color: #ddd;
}

.info-back-btn {
  padding: 10px 24px;
  font-size: 14px;
  color: #667eea;
  background: #fff;
  border: 1px solid #dde0ea;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
}

.info-back-btn:hover {
  background: #667eea;
  color: #fff;
  border-color: #667eea;
}

/* ---- loading ---- */
.player-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
}
</style>
